@switch (display().kind) { @case ("material") {
<span class="material-symbols-outlined menu-icon-mat" aria-hidden="true"
  >{{ display().value }}</span
>
} @case ("dot") {
<svg
  class="menu-icon-dot"
  viewBox="0 0 24 24"
  aria-hidden="true"
  focusable="false"
>
  <circle
    class="menu-icon-dot__ring"
    cx="12"
    cy="12"
    r="7"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
  />
  <circle
    class="menu-icon-dot__core"
    cx="12"
    cy="12"
    r="3.25"
    fill="currentColor"
  />
</svg>
} @case ("none") {} }
